import { Card, CardContent, Typography } from '@mui/material'
import React, { ReactNode } from 'react'

export const SimpleCardBlock = ({ children }: { children: ReactNode }) => {
    return (
        <Card>
            <CardContent>
                <Typography variant='body1'>{children}</Typography>
            </CardContent>
        </Card>
    )
}
